import { render, staticRenderFns } from "./StadiumTaxCreateAndUpdateFormItems.vue?vue&type=template&id=63d52196&"
import script from "./StadiumTaxCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumTaxCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d52196')) {
      api.createRecord('63d52196', component.options)
    } else {
      api.reload('63d52196', component.options)
    }
    module.hot.accept("./StadiumTaxCreateAndUpdateFormItems.vue?vue&type=template&id=63d52196&", function () {
      api.rerender('63d52196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumTaxCreateAndUpdateFormItems.vue"
export default component.exports